import React from 'react';
import { DataLayer } from './DataLayer';
import { GTM } from './GTM';
export var GTMWithDataLayer = function GTMWithDataLayer(_ref) {
  var customScript = _ref.customScript,
    pageEventData = _ref.pageEventData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DataLayer, {
    customScript: customScript,
    pageEventData: JSON.stringify(pageEventData)
  }), /*#__PURE__*/React.createElement(GTM, null));
};